import App from './App';
import HomePage from './pages/home/HomePage';
import AccountPage from './pages/account/AccountPage';
import OperationsPage from './pages/operation/OperationsPage';
import OperationDetailsPage from './pages/operation/OperationDetailsPage';
import TransactionPage from './pages/transaction/TransactionPage';
import TransactionDetailsPage from './pages/transaction/TransactionDetailsPage';
import AssetsPage from './pages/assets/AssetsPage';
import LedgersPage from './pages/ledger/LedgersPage';
import LedgerDetailsPage from './pages/ledger/LedgerDetailsPage';
import NotFoundPage from './pages/NotFoundPage';
import DisclaimerPage from './pages/disclaimer/DisclaimerPage';
import AboutPage from './pages/about/AboutPage';
import PrivacyPolicyPage from './pages/privacyPolicy/PrivacyPolicyPage';
import DevelopersPage from './pages/developers/DevelopersPage';
// import RepoDetailsPage from './pages/developers/RepoDetailsPage';
import CommunityPage from './pages/community/CommunityPage';
import ProjectsPage from './pages/community/ProjectsPage';

// import ProfilePage from './pages/profile/ProfilePage';
// import { userIsAuthenticated } from './util/auth';

export default [
  {
    component: App,
    routes: [
      {
        path: '/',
        component: HomePage,
        exact: true,
      },
      {
        path: '/accounts/:accountId',
        component: AccountPage,
      },
      {
        path: '/operations',
        component: OperationsPage,
        exact: true,
      },
      {
        path: '/operations/:operationId',
        component: OperationDetailsPage,
      },
      {
        path: '/transactions',
        component: TransactionPage,
        exact: true,
      },
      {
        path: '/transactions/:transactionId',
        component: TransactionDetailsPage,
      },
      {
        path: '/assets',
        component: AssetsPage,
        exact: true,
      },
      {
        path: '/ledgers',
        component: LedgersPage,
        exact: true,
      },
      {
        path: '/ledgers/:ledgerId',
        component: LedgerDetailsPage,
      },
      {
        path: '/developers',
        component: DevelopersPage,
        exact: true,
      },
      {
        path: '/community',
        component: CommunityPage,
        exact: true,
      },
      {
        path: '/community/:projectCategory',
        component: ProjectsPage,
      },
      // {
      //   path: '/developers/repositories/:repository',
      //   loadData: RepoDetailsPage.loadData,
      //   component: RepoDetailsPage.component,
      // },
      {
        path: '/disclaimer',
        component: DisclaimerPage,
      },
      {
        path: '/about',
        component: AboutPage,
      },
      {
        path: '/privacy-policy',
        component: PrivacyPolicyPage,
      },
      // {
      //   path: '/profile',
      //   component: userIsAuthenticated(ProfilePage),
      // },
      {
        path: '*',
        component: NotFoundPage,
      },
    ],
  },
];
